import { Flex } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled(Flex)`
  flex: 1 0 0;
  border-radius: 8px;
  gap: 24px;
`;
